var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myPageNewsStoryList"},_vm._l((_vm.articles),function(article){return _c('MyPageNewsStory',_vm._b({key:article.id},'MyPageNewsStory',article,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }